<template>
  <v-expand-transition>
    <div
      v-if="doctorDataStore.selectedWorkplace.appointmentRestrictions?.length"
      class="d-flex flex-column"
      data-qa="appointment_restrictions"
    >
      <div class="d-flex align-center gc-2 mb-2">
        <div class="text-h6 text--text">
          {{ t('Ограничения', options) }}
        </div>
        <span class="ui-icon-error-message ui-icon-fz-medium secondary--text" />
      </div>
      <v-expand-transition>
        <ul :key="doctorDataStore.selectedWorkplace.id">
          <li
            v-for="(item, index) in doctorDataStore.selectedWorkplace.appointmentRestrictions"
            :key="index"
            data-qa="appointment_restrictions_restriction"
            class="text-break"
          >
            {{ item }}
          </li>
        </ul>
      </v-expand-transition>
    </div>
  </v-expand-transition>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import { useDoctorDataStore } from 'www/vue_components/common/AppointmentPage/stores'

const { t, language } = I18NextVue
const options = { ns: language }

const doctorDataStore = useDoctorDataStore()
</script>
